export default __webpack_public_path__ + "static/media/discounts-and-savings.8f2adde9.png";